exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progressGroup[data-v-096ba5e2]{display:flex;gap:0.10417rem;flex-direction:column}.progressGroup .pItem[data-v-096ba5e2]{display:flex;align-items:center;gap:0.10417rem}.progressGroup .pItem .pLabel[data-v-096ba5e2]{flex:0;flex-basis:0.57292rem}.progressGroup .pItem .pProgress[data-v-096ba5e2]{flex:1}.progressGroup .pItem .pNumber[data-v-096ba5e2]{flex:0;flex-basis:0.52083rem}\n", ""]);

// exports
